import { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import VehicleCard from "@/components/VehicleCard";
import { useSite } from "@/lib/site-context";

const CATEGORIES = ["All", "Compact", "Sedan", "SUV", "People Mover"];

export default function Fleet() {
  const { vehicles } = useSite();
  const [params] = useSearchParams();
  const initialCat = params.get("category") || "All";
  const [cat, setCat] = useState(initialCat);
  const [sort, setSort] = useState("price-asc");

  const filtered = useMemo(() => {
    let list = vehicles.filter((v) => cat === "All" || v.category.toLowerCase() === cat.toLowerCase());
    if (sort === "price-asc") list = [...list].sort((a, b) => a.daily_rate - b.daily_rate);
    if (sort === "price-desc") list = [...list].sort((a, b) => b.daily_rate - a.daily_rate);
    if (sort === "passengers") list = [...list].sort((a, b) => b.passengers - a.passengers);
    return list;
  }, [vehicles, cat, sort]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
      <div className="text-[11px] uppercase tracking-[0.25em] text-[#D9A62E] font-mono-piki font-semibold">Our Fleet</div>
      <h1 className="mt-3 font-display text-4xl sm:text-5xl font-extrabold text-white">Choose Your Ride</h1>
      <p className="mt-3 text-[#A3A3A3] max-w-xl">Browse our full range of well-maintained vehicles — from compact city cars to spacious people movers.</p>

      <div className="mt-10 flex flex-wrap items-center justify-between gap-4">
        <div className="flex flex-wrap gap-2">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              data-testid={`fleet-filter-category-${c.toLowerCase().replace(" ", "-")}-btn`}
              className={`px-4 py-2 rounded-full text-sm font-semibold transition-all ${
                cat === c ? "bg-[#D9A62E] text-[#050505]" : "border border-[#2E2E2E] text-[#D4D4D4] hover:border-[#D9A62E] hover:text-[#D9A62E]"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
        <select
          value={sort}
          onChange={(e) => setSort(e.target.value)}
          data-testid="fleet-sort-select"
          className="piki-input text-sm max-w-xs"
        >
          <option value="price-asc">Price: Low to High</option>
          <option value="price-desc">Price: High to Low</option>
          <option value="passengers">Most Passengers</option>
        </select>
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {filtered.map((v) => <VehicleCard key={v.id} v={v} />)}
      </div>
      {filtered.length === 0 && (
        <div className="text-center py-16 text-[#737373]">No vehicles match the current filter.</div>
      )}
    </div>
  );
}
